import { enqueueSnackbar, somethingWrongNotification } from '../redux/notifier/notifierActions';

const projectErrorHandler = (e, dispatch, rejectWithValue) => {
  if (e.response.status === 409) {
    dispatch(
      enqueueSnackbar({
        message: 'projectInUse',
        options: {
          variant: 'warning',
          subMessage: 'thisProjectIsCurrentlyUsing',
          subMessageParams: {
            username: e.response.data.username ?? '',
          },
        },
      }),
    );

    history.push('/projects');
    return rejectWithValue(e);
  }

  dispatch(somethingWrongNotification());
  return rejectWithValue(e);
};

export default projectErrorHandler;
